export default {
    Title: "Nhật ký truy cập",
    UserUsing: "Người dùng",
    Time: "Thời gian",
    Action: "Hành động",
    Reference: "Tham chiếu",
    Description: "Mô tả",
    IPAddress: "Địa chỉ IP",
    Organization: "Chi nhánh, phòng ban",
    Filter: "Bộ lọc",
    DateFilter: "Kỳ",
    SearchFilter: "Nhập Người dùng, Tham chiếu, Mô tả, Địa chỉ IP để tìm kiếm",
    OrgStructure: "Cơ cấu tổ chức",
    ActionDetail : 'Chi tiết hành động',
}